import { styled } from "@schaeffler-commerce/design-system";
import { Link, type LinkProps } from "~/common/components/Link";
import { type ReactNode } from "react";
import { forwardRef } from "react";
import classNames from "classnames";

interface Props extends Omit<LinkProps<"button">, "children" | "component"> {
  icon: ReactNode;
  outlinedIcon?: boolean;
  active?: boolean;
}

export const MobileNavButton = forwardRef<HTMLButtonElement, Props>(
  ({ active, icon, outlinedIcon, className, ...rest }, ref) => {
    return (
      <StyledMobileNavAction
        component="button"
        type="button"
        className={classNames(
          "scha__mobile-navigation__button",
          outlinedIcon && "scha__mobile-navigation__button--outlined-icon",
          className,
        )}
        appearance={active ? "primary" : "navigation"}
        ref={ref}
        {...rest}
      >
        {icon}
      </StyledMobileNavAction>
    );
  },
);

const StyledMobileNavAction = styled(Link)(({ theme }) => ({
  flex: "none",
  marginRight: theme.spacing(1),
  [theme.breakpoints.down("desktop-s")]: {
    height: theme.spacing(6),
    width: theme.spacing(6),
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  "&.scha__link--navigation": {
    color: theme.palette.text.secondary,
  },
  "&.scha__mobile-navigation__button--outlined-icon svg": {
    outline: `1px solid ${theme.palette.divider}`,
    outlineOffset: theme.spacing(1),
    borderRadius: "50%",
  },
})) as typeof Link;
